import React,{useState,useEffect, useRef} from 'react';
import '../styles/ScrollHandler.css'
import arrow_colored from '../images/down-arrow.png'
import arrow_outline from '../images/arrow-outline.png'
const ScrollHandler = ({setStage,stage})=>{
    const step = useRef(0)
    const canScroll = useRef(true)
    const sectionContainer = document.getElementsByClassName("sectionsContainer")
    const sections = document.getElementsByClassName("section")
    const [offsetTop,setOffsetTop] = useState()
    const currentSection = useRef(0)
    const [isFirst,setIsFirst] = useState(true)
    const [isLast,setIsLast] = useState(false)
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let p_1 = document.getElementById('first-part')
    let p_2 = document.getElementById('second-part')
    let p_3 = document.getElementById('third-part')
    let p_4 = document.getElementById('fourth-part')
    let p_5 = document.getElementById('fifth-part')
    let p_6 = document.getElementById('sixth-part')
    const parts = [p_1,p_2,p_3,p_4,p_5,p_6]
    

    window.addEventListener('resize',()=>{
        
       /* 
        //const scroll_Top = window.pageYOffset || document.documentElement.scrollTop;
        const contH = sectionContainer[0].offsetHeight
        const sc_ = document.getElementById('second-part')
        const scH = sc_.offsetHeight
        
        const adj = (contH - scH)
       
        
      let diff =  sc_ - sc
      */
     
      currentSection.current = 0
      setStage(currentSection.current)
      sectionContainer[0].style.top = 0 +'px'
    
    })
    
        window.addEventListener('wheel',(event)=>{
            const direction = event.deltaY > 1 ? 1: -1
            
            if(!canScroll.current){
                
                return
                
                
                
        }
        
        canScroll.current = false
            
           setTimeout(()=>{
            
            canScroll.current = true
                
            },2000)
            
            performScroll(direction)
        })
        
      


const performScroll = (directionValue)=>{
   
    currentSection.current += directionValue
    console.log(currentSection)  
    setStage(currentSection.current)
    
    if(currentSection.current >= sections.length -1){
        currentSection.current = sections.length -1
        setIsLast(true)
    }
    else if(currentSection.current <= 0){
        currentSection.current = 0 
        setIsFirst(true)
    }else{
        setIsFirst(false)
        setIsLast(false)
    }
    
    let part = parts[currentSection.current].getBoundingClientRect().top
    let diff = part+scrollTop
    let previousTop = sectionContainer[0].style.top.replace('px','')
    if(currentSection.current> 0){

        const to_down_calc = (part - parts[currentSection.current-1].getBoundingClientRect().top) + scrollTop
        const to_up_calc = (parts[currentSection.current-1].getBoundingClientRect().top -part) + scrollTop
        diff =  directionValue === 1 ? to_down_calc : to_up_calc 
       console.log('diff:',diff)
    }
    setOffsetTop(diff)
    
   

    sectionContainer[0].style.top = (previousTop-diff) +'px'
    console.log('styleTop : ',sectionContainer[0].style.top)
     
    //sectionContainer[0].style.top = (currentSection.current * -120) +'vh'


}
const toUp = ()=>{
    performScroll(-1)
}
const toDown = ()=>{
    performScroll(1)
}


    return(
    <div className='scroll-buttons-container'>
        
    {!isFirst && isFirst !== null && <div className='up-button' onClick={toUp}>
    <img style={{width:"60px"}} src={arrow_outline} />
    </div>}
    {!isLast && isLast !== null && <div className='down-button' onClick={toDown}>
    <img style={{width:"60px"}} src={arrow_colored} />
    

    </div>}
    </div>
    )
}
export default ScrollHandler;